/**
 * Independent time operation tool to facilitate subsequent switch to dayjs
 */
import dayjs from 'dayjs'

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DATE_FORMAT = 'YYYY-MM-DD'

export function formatToDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  return dayjs(date).format(format)
}

export function formatToDate(date?: dayjs.ConfigType, format = DATE_FORMAT): string {
  return dayjs(date).format(format)
}

export function beginOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999)
}

export function betweenDay(date1, date2) {
  date1 = convertDate(date1)
  date2 = convertDate(date2)
  // 计算差值
  return Math.floor((date2.getTime() - date1.getTime()) / (24 * 3600 * 1000))
}

export function formatDate(date: Date, format?: string): string {
  // 日期不存在，则返回空
  if (!date)
    return ''

  // 日期存在，则进行格式化
  if (format === undefined)
    format = 'YYYY-MM-DD HH:mm:ss'

  return dayjs(date).format(format)
}

export function addTime(date, time) {
  date = convertDate(date)
  return new Date(date.getTime() + time)
}

export function convertDate(date) {
  if (['string', 'number'].includes(typeof date))
    return new Date(date)

  return date
}

/**
 * 日期格式化
 * @param date 日期
 * @param block 格式化字符串
 */
export function dateFormat(date, block) {
  if (!date)
    return ''

  let format = block || 'yyyy-MM-dd'
  date = new Date(date)
  const map = {
    M: date.getMonth() + 1, // 月份
    d: date.getDate(), // 日
    h: date.getHours(), // 小时
    m: date.getMinutes(), // 分
    s: date.getSeconds(), // 秒
    q: Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
    let v = map[t]
    if (v !== undefined) {
      if (all.length > 1) {
        v = `0${v}`
        v = v.substr(v.length - 2)
      }
      return v
    }
    else if (t === 'y') {
      return date
        .getFullYear()
        .toString()
        .substr(4 - all.length)
    }
    return all
  })
  return format
}

/**
 * 将毫秒，转换成时间字符串。例如说，xx 分钟
 *
 * @param ms 毫秒
 * @returns {string} 字符串
 */
export function getDate(ms) {
  const day = Math.floor(ms / (24 * 60 * 60 * 1000))
  const hour = Math.floor(ms / (60 * 60 * 1000) - day * 24)
  const minute = Math.floor(ms / (60 * 1000) - day * 24 * 60 - hour * 60)
  const second = Math.floor(ms / 1000 - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60)
  if (day > 0)
    return `${day}天${hour}小时${minute}分钟`

  if (hour > 0)
    return `${hour}小时${minute}分钟`

  if (minute > 0)
    return `${minute}分钟`

  if (second > 0)
    return `${second}秒`
  else
    return `${0}秒`
}

export const dateUtil = dayjs
